"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavItemShop = NavItemShop;
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const useStyles = (0, react_jss_1.createUseStyles)({
    chip: {
        position: "absolute",
        top: "-16px",
        width: "100%",
    },
    chipText: {
        fontSize: "12px",
        padding: "0.25em",
        borderRadius: "4px",
        background: "#b13e53",
        letterSpacing: "1px",
    },
});
function NavItemShop() {
    const styles = useStyles();
    const shopLocked = (0, react_redux_1.useSelector)((state) => state.game.cardShop.locked);
    if (shopLocked === false) {
        return null;
    }
    return (react_1.default.createElement("div", { className: styles.chip },
        react_1.default.createElement("span", { className: styles.chipText }, "LOCKED")));
}
